const C = require("../constants");

const showAlert = (data) => {
    return {
        type: C.SHOW_ALERT,
        data
    }
};

export {showAlert};


// WEBPACK FOOTER //
// ./src/actions/AlertAction.js